import { useBulkUpdatePayPeriods } from './hooks/useBulkUpdatePayPeriods'
import { useComboPaySubscription } from './hooks/useCompoPaySubscription'
import { useCreatePayPeriod } from './hooks/useCreatePayPeriod'
import { useDeletePayPeriod } from './hooks/useDeletePayPeriod'
import { useFetchPayPeriod } from './hooks/useFetchPayPeriod'
import { useFetchPayPeriods } from './hooks/useFetchPayPeriods'
import { useSubmitPayPeriodToCompoPay } from './hooks/useSubmitPayPeriodToComboPay'
import { useSynchronizePayPeriodToCompoPay } from './hooks/useSyncronizePayPeriodToComboPay'

class PayPeriodService {
  payPeriod = {
    useFetchAll: useFetchPayPeriods,
    useFetchOne: useFetchPayPeriod,
    useCreate: useCreatePayPeriod,
    useBulkUpdate: useBulkUpdatePayPeriods,
    useDelete: useDeletePayPeriod,
    useSynchronizeToComboPay: useSynchronizePayPeriodToCompoPay,
    useSubmitToComboPay: useSubmitPayPeriodToCompoPay,
    useSubmitToComboPaySubscription: useComboPaySubscription
  }
}

export const payPeriodService = new PayPeriodService()
